<mat-card [class.mat-elevation-z0]='!elevate' class='no-card-box'>
  <mat-card-content>
    @if (showHeaderToolbar) {
      <dataset-filter
        [loading]='datasetACS.loading.value'
        [actionButtons]='globalActionButtons'
        [showSearchText]='showSearchBar && viewConfig.showSearchBar'
        [filtersData]='filtersData'
        (filterChange)='datasetACS.putDatasetData("filters", $event)'
        [formConfig]="viewConfig.filterForm"
        [dataContainerService]='datasetACS'
      ></dataset-filter>
    }
    @if (!showHeaderToolbar && datasetACS.loading.value) {
      <mat-progress-bar mode='indeterminate'></mat-progress-bar>
    }
    @if (!datasetACS.loading.value && paginationResponse && paginationResponse.items && paginationResponse.items.length == 0) {
      <div>
        <p class='pl-16'>{{'Nessun elemento presente' | translate}}</p>
      </div>
    }
    @if (paginationResponse && paginationResponse.items && paginationResponse.items.length !== 0) {
      <div class='custom-list-items-container'>
        @for (item of paginationResponse.items; track trackById($index, item)) {
          @switch (datasetACS.datasetConfig.name) {
            @case ("trip_booking_discounts") {
              <trip-booking-discount-item-view
                [parentDatasetACS]='datasetACS'
                [item]='item'
                (delete)='onDelete(item)'
              ></trip-booking-discount-item-view>
            }
            @case ("trip_booking_participant_extras") {
              <trip-booking-participant-item-view
                [parentDatasetACS]='datasetACS'
                [item]='item'
                (edit)="openEdit(item)"
                (selected)="selected.emit(item)"
              ></trip-booking-participant-item-view>
            }
            @case ("trip_booking_resources") {
              <trip-booking-resource-item-view
                [parentDatasetACS]='datasetACS'
                [item]='item'
                (edit)="openEdit(item)"
                (reloadDatasetList)="reload()"
                (selectedResource)="selected.emit($event)"
              ></trip-booking-resource-item-view>
            }
            @case ("actual_trip_group_trip_resources") {
              <actual-trip-group-trip-resources-item-view
                [parentDatasetACS]='datasetACS'
                [item]='item'
                (delete)='onDelete(item)'
                (addItem)='onAdd()'
              ></actual-trip-group-trip-resources-item-view>
            }
            @case ("trip_options_for_open_dates") {
              <trip-options-for-virtual-trips-list-item-view
                [item]='item'
                (delete)='onDelete(item)'
                (edit)="openEdit(item)"
              ></trip-options-for-virtual-trips-list-item-view>
            }
            @case ("trip_options_for_virtual_trips") {
              <trip-options-for-virtual-trips-list-item-view
                [item]='item'
                (delete)='onDelete(item)'
                (edit)="openEdit(item)"
              ></trip-options-for-virtual-trips-list-item-view>
            }
            @default {
              <p>No custom item view defined for {{datasetACS.datasetConfig.name}}</p>
            }
          }
        }
      </div>
    }

  </mat-card-content>
  @if (canCreate || hasGlobalButtons || showPaginationComponent) {
    <mat-card-footer>
      <mat-toolbar>
        <span class="fx-flex"></span>
        @if (showPaginationComponent) {
          <mat-paginator
            [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"
            showFirstLastButtons
            [class.hide-last-page-button]='totalCapped'
            [length]="paginationResponse.meta.total"
            [pageSize]="paginationResponse.meta.perPage"
            (page)="onPaginatorChange($event)">
          </mat-paginator>
        }
      </mat-toolbar>
    </mat-card-footer>
  }
</mat-card>
